/**
 * @generated SignedSource<<3f4e97f4e3e4ce973952574d861d9e7b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type uUserActivityFragment$data = {
  readonly activities: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: string;
        readonly id?: string;
        readonly " $fragmentSpreads": FragmentRefs<"commentPreviewFragment" | "postPreviewFragment">;
      };
    }>;
    readonly pageInfo: {
      readonly hasNextPage: boolean;
    };
  };
  readonly id: string;
  readonly " $fragmentType": "uUserActivityFragment";
};
export type uUserActivityFragment$key = {
  readonly " $data"?: uUserActivityFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"uUserActivityFragment">;
};

import uUserActivityFragmentQuery_graphql from './uUserActivityFragmentQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "activities"
],
v1 = {
  "kind": "Variable",
  "name": "club",
  "variableName": "club"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "club"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "contentType"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": 10,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": uUserActivityFragmentQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "uUserActivityFragment",
  "selections": [
    {
      "alias": "activities",
      "args": [
        (v1/*: any*/),
        {
          "kind": "Variable",
          "name": "contentType",
          "variableName": "contentType"
        }
      ],
      "concreteType": "UserActivityConnection",
      "kind": "LinkedField",
      "name": "__uUser_activities_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserActivityEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v2/*: any*/),
                    {
                      "args": [
                        (v1/*: any*/)
                      ],
                      "kind": "FragmentSpread",
                      "name": "postPreviewFragment"
                    }
                  ],
                  "type": "Post",
                  "abstractKey": null
                },
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "commentPreviewFragment"
                    }
                  ],
                  "type": "CommentInterface",
                  "abstractKey": "__isCommentInterface"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v2/*: any*/)
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "b504baaddbda37672d4d2fe1e1a3b43a";

export default node;
